export default __webpack_public_path__ + "static/media/loader.f17194b9.gif";